import { action } from '@ember/object';
import Component from '@glimmer/component';

import FormCheckboxSwitchComponent from 'webapp/components/form/checkbox-switch';

import type Block from 'webapp/models-custom/block';

interface Args {
	blockM: Block;
}

export default class BlockSettingsHideTimeLeftComponent extends Component<Args> {
	get block(): Block {
		return this.args.blockM;
	}

	get blockSetup() {
		return this.block.blockSetup;
	}

	get selected(): boolean {
		return !!this.block.hideTimeLeft;
	}

	@action
	changeSelected(selected: boolean): void {
		this.block.hideTimeLeft = selected;
		this.blockSetup.trackBlockPropertySettingsChangeEvent({ hide_time_left: selected });
		this.blockSetup.saveBlock();
	}
	<template>
		<div class="row row--toggle">
			<FormCheckboxSwitchComponent
				@name="hideTimeLeft"
				@selected={{this.selected}}
				@onChange={{this.changeSelected}}
			/>
			<label>
				Hide time left
			</label>
		</div>
	</template>
}
